//  add to this dictionary for any errors that may be seen throughout the app.
//  organized by model - accepts a key for has-many models (e.g. rates/timeSlots)
//  prevents common typos when grabbing an error string and
//  organizes all errors into one file

export const ERRORS_OBJ = {
  rates: {
    NO_NAME: key => `ticketsErrorRateTitle_${key}`, // no name entered
    NO_PRICE: key => `ticketsErrorNoPrice_${key}`, // no price entered
    INVALID_PRICE: key => `ticketsErrorInvalidPrice_${key}`, // invalid price entered (e.g. -2)
    NO_START_DATE: key => `ticketsNoStartDate_${key}`, // invalid start date entered
    NO_START_TIME: key => `ticketsNoStartTime_${key}`, // invalid start time entered
    NO_END_DATE: key => `ticketsNoEndDate_${key}`, // invalid end date entered
    NO_END_TIME: key => `ticketsNoEndTime_${key}`, // invalid end time entered
    INVALID_CAPACITY: key => `ticketsInvalidCapacity_${key}`, // invalid capacity entered (e.g. -20)
    END_DATE_BEFORE_START_DATE: key => `ticketsErrorDateRange_${key}`, // end date is before the start date
    START_IS_AFTER_EVENT_END: key => `ticketsErrorStartDateIsAfterEventEnd_${key}`, // start is after the event end
    MAX_QUANTITY_LOWER_THAN_MIN: key => `ticketsErrorMaxQuantityLowerThanMin_${key}`, // max qty lower than min qty
    INVALID_MAX_REDEMPTIONS: key => `ticketsInvalidMaxRedemptions_${key}`, // invalid max redemptions (e.g. -20)
    NO_REDEMPTION_MESSAGE: key => `ticketsErrorNoRedemptionMessage_${key}`, // redemption alert active without msg
  },
  listing: {
    NO_TITLE: () => `basicErrorTitle`, // invalid event capacity entered (e.g. -2)
    NO_DESCRIPTION: () => `basicErrorDescription`, // invalid event capacity entered (e.g. -2)
    NO_ADDRESS: () => `locationErrorAddress`, // no address entered
    ILLEGAL_COUNTRY_CHANGE: () => 'illegalCountryChange', // country change not allowed
    BLACKLISTED_COUNTRY: () => `blacklistedCountryError`, // blacklisted country detected
    INVALID_CAPACITY: () => `invalidCapacity`, // invalid event capacity entered (e.g. -2)
    CAPACITY_REQUIRED: () => 'capacityRequired', // when urgency indicator is True but capacity is 0
    NO_RATES: () => `ticketsErrorNoRates`, // no rates exist
    DUPLICATE_RATE_NAMES: () => `ticketsErrorDistinctRates`, // duplicate rate names exist
    NO_TIMESLOTS: () => `ticketsNoTimeSlots`, // no timeslots exists
    INVALID_TIMEZONE: () => `invalidTimezone`, // (WEB-12775) remove this when tz changes do not mutate timeslots
    NO_VIRTUAL_INFO: () => `locationErrorNoVirtualInfo`, // no virtual_info / virtual event connection details exist
    NO_BUSINESS_EMAIL: () => 'invalidBusinessEmail',
    NO_BUSINESS_PHONE: () => 'invalidBusinessPhone',
    NO_BUSINESS_ADDRESS: () => 'invalidBusinessAddress',
    NO_AGE_LIMIT: () => 'basicErrorAgeLimit',
  },
  timeSlots: {
    NO_START_DATE: key => `locationErrorStartDate_${key}`,
    NO_START_TIME: key => `locationErrorStartTime_${key}`,
    NO_END_DATE: key => `locationErrorEndDate_${key}`,
    NO_END_TIME: key => `locationErrorEndTime_${key}`,
    END_DATE_BEFORE_START_DATE: key => `locationErrorDateRange_${key}`,
    DATE_IS_BEFORE_CURRENT_TIME: key => `locationErrorTimeBeforeCurrentTime_${key}`,
    OVERLAPPING_DATETIME: key => `overlappingTimeslots_${key}`, // duplicate datetime signature exists with another ts
  },
  attractions: {
    INVALID_WIDGET: () => 'attractionErrorWidget',
  },
  fees: {
    INVALID_FEE: id => `invalidFee_${id}`,
  },
  remindMe: {
    REMIND_ME_TIMING: () => 'fanReminderTiming',
  },
};
